import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Module } from '../../modules/services/firmware/firmware.service';

@Component({
  selector: 'module-search',
  templateUrl: './module-search.component.html',
  styleUrls: ['./module-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModuleSearchComponent implements OnInit {
  @Input() modules: ModuleRef[];
  @Input() enableDeviceTypes: boolean;
  @Input() autoClearInput: boolean;
  @Input() placeHolder: string;
  @Input() moduleDisplayName: string;
  @Input() disableAfterSelection = false;
  @Output() module: EventEmitter<ModuleRef> = new EventEmitter<ModuleRef>();
  @ViewChild('input', { static: false }) input: ElementRef;
  searchFailed: boolean;

  model: any;
  selectedModules: ModuleRef[] = [];

  searchModuleBinding: (searched: Observable<string>) => Observable<Module[]>;

  constructor(private cdr: ChangeDetectorRef) {}

  async ngOnInit(): Promise<void> {
    this.searchModuleBinding = this.searchModules.bind(this);
  }

  searchModules = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2
          ? []
          : this.modules.filter((module) =>
              this.enableDeviceTypes
                ? this.deviceTypeTermMatch(module, term)
                : this.insightsTermMatch(module, term),
            ),
      ),
    );

  private insightsTermMatch(module: ModuleRef, term: string): boolean {
    return (
      module.name.toLowerCase().includes(term.toLowerCase()) ||
      (module.version.toLowerCase().includes(term.toLowerCase()) &&
        !this.selectedModules.includes(module))
    );
  }

  private deviceTypeTermMatch(module: ModuleRef, term: string): boolean {
    return (
      module.platform.toLowerCase().includes(term.toLowerCase()) &&
      !this.selectedModules.includes(module)
    );
  }

  onSelectItem(event: any) {
    this.module.emit(event.item);
    this.selectedModules.push(event.item);
    event.preventDefault?.();
    this.input.nativeElement.value = event.item.platform;

    // //Clear the typeahead input field
    if (this.autoClearInput) {
      this.clearInput();
    }
  }
  clearInput() {
    this.input.nativeElement.value = '';
    this.cdr.detectChanges();
  }

  formatter = (result: { name: string; version: string }) =>
    result.name + ' (' + result.version + ')';

  formatModule(module: ModuleRef): string {
    try {
      if (this.enableDeviceTypes) {
        return module.platform;
      } else {
        const moduleStringList = [];
        moduleStringList.push(module.name);
        moduleStringList.push(module.version);
        return moduleStringList.join(' > ');
      }
    } catch (e) {
      return '';
    }
  }
}

export interface ModuleRef {
  name: string;
  version: string;
  platform?: string;
  hardwarePlatform?: string;
  configuration?: string;
  configurationSchema?: string;
}
